export default __webpack_public_path__ + "static/APP_4_5-8ca44d6bbcf6de0b080eb5297c5a4474.png";